import { ActionButtonVariants } from 'components/action-button';

export default {
  buttonVariant: ActionButtonVariants.OUTLINE,
  hasStartIcon: false,
  showNumItems: false,
  isSquare: true,
};
